import React from 'react';
import LazyImage from '../components/LazyImage';
import '../styles/Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero-section">
      <div className="container">
        
        {/* Main Title with Photo Texture */}
        <div className="hero-title-wrapper">
            <h1 className="hero-title">
                <span className="photo-text" data-text="HORAZEL">HORAZEL</span>
                <span className="photo-text" data-text="PHOTOGRAPHY">PHOTOGRAPHY</span>
            </h1>
        </div>

        {/* About Section */}
        <div className="hero-about-section">
          <div className="about-content">
            <div className="about-text-col">
              <h2 className="about-headline">
                LENS AND LIFE<br/>
                EXPLORING THE<br/>
                WORLD THROUGH<br/>
                PHOTOGRAPHY
              </h2>
              <p className="about-desc">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean 
                pellentesque suscipit justo, ac lacinia nunc vehicula a. In nec lorem 
                quis neque pulvinar faucibus ac ac sapien.
              </p>
              <button className="read-more-btn">READ MORE</button>
            </div>
            
            <div className="about-images-col">
              <div className="about-img about-img-1">
                <LazyImage src={require('../assets/images/s1_1.jpg')} alt="Photographer" />
              </div>
              <div className="about-img about-img-2">
                <LazyImage src={require('../assets/images/s1_2.jpg')} alt="Photographer" />
              </div>
            </div>
          </div>
          
          {/* Brand Logos */}
          <div className="brand-logos">
            <span className="brand-logo">VOGUE</span>
            <span className="brand-logo loreal">L'OREAL</span>
            <span className="brand-logo avon">AVON</span>
            <span className="brand-logo chanel">CHANEL</span>
            <span className="brand-logo armani">ARMANI</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Hero;
